const not = (x) => !x;
export default not;
